import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { PageSize } from '@uhg-abyss/web/ui/Pagination';
import React from 'react';

type ResultsPerPageProps = {
  pageSizeOptions: number[];
  resultsPerPage: number;
  setResultsPerPage: (size: number) => void;
};

/**
 * ResultsPerPage
 *
 * Allows the user to select the number of results to display per page.
 */
export function ResultsPerPage({
  pageSizeOptions = [25, 50, 100, 200],
  resultsPerPage = 25,
  setResultsPerPage = () => {},
}: ResultsPerPageProps) {
  return (
    <ErrorHandler location="src/shared/ui/components/TableQuery/components/Header/components/ResultsPerPage/ResultsPerPage.tsx">
      <PageSize pageSize={resultsPerPage} pageSizeOptions={pageSizeOptions} setPageSize={setResultsPerPage} />
    </ErrorHandler>
  );
}
